import { useUser, useOrganization } from '@clerk/clerk-react'

import { useUserRole } from './useUserRole'

interface PendingOrganizationState {
  role: string
  requiresOrganization: boolean
  isPending: boolean
  isLoaded: boolean
}

export function usePendingOrganization(): PendingOrganizationState {
  const { isSignedIn, isLoaded: isUserLoaded } = useUser()
  const { organization, isLoaded: isOrgLoaded } = useOrganization()
  const { role } = useUserRole()

  const requiresOrganization = isSignedIn && (role === 'provider' || role === 'gcc')
  const isLoaded = isUserLoaded && isOrgLoaded
  const isPending = isLoaded && requiresOrganization && !organization?.id

  return {
    role,
    requiresOrganization,
    isPending,
    isLoaded
  }
}

